import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FormError from './FormError';

const FormInputText = (props) => {
    const { label, type, value, handleChange, classes, name, error, myRef, readOnly, hideLabel } = props;
    const disabled = typeof props.disabled === 'undefined' ? false : props.disabled;

    return (
        <Fragment>
            {hideLabel ? '' : <label>{label}</label>}
            <input
                ref={myRef}
                type={type}
                placeholder={`${label}...`}
                className={classes + ' text-uppercase'}
                value={value}
                onChange={(e) => handleChange(e)}
                name={name}
                disabled={disabled}
                readOnly={readOnly}
            />
            <FormError error={error} />
        </Fragment>
    );
};

export default FormInputText;
